import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { enviroment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { hydrateSessionOnStartup } from './app/shared/session-cookie.util';
import { stripUrlFragment } from './app/shared/desktop-handoff.util';

/**
 * Este projeto roda com sendDefaultPii: true, então a Sentry anexa a URL da página — com
 * fragmento — em erros, transações de navegação e breadcrumbs.
 *
 * O handoff do desktop não usa mais o fragmento (o token virou código de uso único, ver
 * desktop-handoff.util.ts), mas o scrubbing fica: é barato, e nada que apareça num fragmento
 * desta aplicação deveria sair dela.
 */
function scrubUrlFragments(event: any): any {
  const request = event?.request;
  if (request?.url) request.url = stripUrlFragment(request.url);
  if (request?.headers?.['Referer']) {
    request.headers['Referer'] = stripUrlFragment(request.headers['Referer']);
  }
  event?.breadcrumbs?.forEach((crumb: any) => {
    if (crumb?.data?.from) crumb.data.from = stripUrlFragment(crumb.data.from);
    if (crumb?.data?.to) crumb.data.to = stripUrlFragment(crumb.data.to);
  });
  return event;
}

Sentry.init({
  dsn: 'https://c54f23447629f61250fd843fe51357eb@o4510230597140480.ingest.us.sentry.io/4511344473473024',
  sendDefaultPii: true,
  beforeSend: scrubUrlFragments,
  beforeSendTransaction: scrubUrlFragments,
});

if(enviroment.PRODUCTION) {
  enableProdMode();
}

// Hidrata a sessão (localStorage → sessionStorage) ANTES de o Angular subir, para que
// nenhuma aba nova leia um sessionStorage vazio e dispare /user/active sem idToken.
hydrateSessionOnStartup();

// O handoff do desktop (Vision) roda no APP_INITIALIZER, dentro de AuthService.bootstrapSession()
// — a troca do código por tokens é assíncrona e precisa acontecer antes do Router.

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
